import { setOptions } from '@biw/client-fetch';

import config from 'app/config';

export default function setFetchOptions() {
    setOptions( {
        baseURL: config.API_URL,
        headers: {
            'x-company-code': config.COMPANY_CODE
        }
    } );
}
